import axios from "axios";
import { get } from "../common/api-service";

const AuthAPI = {
    async getUserPermissions() {
        const url = `/auth/user-permissions`;
        return await get(url);
    },

    async testUserStatus() {
        const url = `${import.meta.env.VITE_BFF_PROXY}/sarm/connect/userinfo`;
        return await axios.get(url, {
            withCredentials: true,
            headers: {
                "X-CSRF": "1",
            },
        });
    },
};

export default AuthAPI;
